import { render, staticRenderFns } from "./SupplierContactHome.vue?vue&type=template&id=4c82f254&scoped=true&"
import script from "./SupplierContactHome.vue?vue&type=script&lang=js&"
export * from "./SupplierContactHome.vue?vue&type=script&lang=js&"
import style0 from "./SupplierContactHome.vue?vue&type=style&index=0&id=4c82f254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82f254",
  null
  
)

export default component.exports